<template>
  <div class="common-footer">
    <div class="dialog" v-show="visible">
      <div
        style="width: 330px;height: 100px; background-color: #fff;font-size: 14px;border-radius: 10px;padding-top: 38px;">
        <div style="text-align: center;">Địa chỉ email：TTHOAGamesVN@gmail.com</div>
        <div style="margin-top: 15px;text-align: right;padding-right: 15px;color: #44aaff;" @click="visible = false">Đóng
        </div>
      </div>
    </div>
    <div class="delete" @click="open">Xóa tài khoản</div>

    <div class="privacy" @click="jump('https://sdkinit.phuhocongluoc.vn/protocol?appId=10123&typeFlag=1&language=9')">CHÍNH SÁCH BẢO MẬT</div>
    <div class="useragreement" @click="jump('https://sdkinit.phuhocongluoc.vn/protocol?appId=10123&typeFlag=2&language=9')">ĐIỀU KHOẢN VÀ ĐIỀU KIỆN SỬ DỤNG DỊCH VỤ</div>
  </div>
</template>
<script>
import DialogLayer from './DialogLayer';
import { jumpUrlNewWindow } from '@/js/common.js';
export default {
  components: {
    DialogLayer,
  },
  data(){
    return{
      visible: false
    }
  },
  mounted() {
  },
  methods: {
    open() {
      this.visible = true
    },
    jump(url){
      jumpUrlNewWindow(url)
    }
  }
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 769px) {
  .common-footer {
    width: 100%;
    height: 180px;
    background-image: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/footer--pc.png);
    background-size: 100%;
    background-repeat: no-repeat;
    position: relative;

    .delete {
      position: absolute;
      font-size: 14PX;
      color: #FFF;
      left: 570px;
      top: 140px;
    }

    .privacy{
      position: absolute;
      font-size: 14PX;
      color: #FFF;
      left: 820px;
      top: 140px;
    }
    .useragreement{
      position: absolute;
      font-size: 14PX;
      color: #FFF;
      left: 1020px;
      top: 140px;
    }

    .dialog {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 2200;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

@media screen and (max-width: 768px) {
  .common-footer {
    position: relative;

    width: 100%;
    height: 288px;
    background-image: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/footer--mobile.png);
    background-size: 100%;
    background-repeat: no-repeat;
    .delete {
      position: absolute;
      font-size: 12PX;
      color: #ccc;
      left: 50px;
      top: 70px;
    }

    .privacy{
      position: absolute;
      font-size: 8PX;
      color: #ccc;
      left: 45px;
      bottom: 5px;
    }
    .useragreement{
      position: absolute;
      font-size: 8PX;
      color: #ccc;
      left: 250px;
      bottom: 5px;
    }
    
    .dialog {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 2200;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
